import ErrorHandler from '../components/ErrorHandler';
import { BoxRes, ImportParams, ImportStatus } from '../types/Box';
import { ImportScanItemRes, PatchScanPayload, ScanOrBoxSubmitRes, ScanRes } from '../types/Scan';
import { client } from './Client';

export const getPaginatedScans = async (params: string) => {
    return client
        .get<ScanRes>(`/scans?${params}`)
        .then((response) => response.data)
        .catch(ErrorHandler);
};

export const getScan = async (scanId: string) => {
    return client.get<ScanRes>(`/scans/${scanId}`).then((response) => response.data);
};

export const getBox = async (boxId: string) =>
    client.get<BoxRes>(`/scans/box/${boxId}`).then((response) => response.data);

export const createScan = async (payload: PatchScanPayload): Promise<ScanRes> =>
    client.post<ScanRes>('/scans', payload).then((response) => response.data);

export const createBox = async ({ scanId }: { scanId: number }): Promise<BoxRes> =>
    await client.post(`/scans/${scanId}/box`).then((response) => response.data);

export const updateScan = async (scanId: number, payload: PatchScanPayload): Promise<ScanRes> =>
    client.patch(`/scans/${scanId}`, payload).then((res) => res.data);

export const deleteScanById = (scanId: number) => client.delete(`/scans/${scanId}`);

export const deleteBoxById = async ({
    scanId,
    boxId
}: {
    scanId: number;
    boxId: number;
}): Promise<{ scanId: number }> => {
    return client.delete(`/scans/${scanId}/box/${boxId}`);
};

export const completeScanOrBox = async ({
    scanId,
    boxId,
    loggerList
}: {
    scanId?: string;
    boxId?: string;
    loggerList?: Array<any>;
}): Promise<ScanOrBoxSubmitRes> => {
    if (!scanId) throw new Error('scanId is required');
    const boxUrlPart = boxId ? `/box/${boxId}` : '';
    const url = `/scans/${scanId}${boxUrlPart}/submit`;
    return client.post(url, loggerList).then((res) => res.data);
};

export const fetchScanStatus = async ({ scanId }: { scanId: number | string }): Promise<ImportStatus> =>
    client.get<ImportStatus>(`/scans/${scanId}/import/status`).then((res) => res.data);

export const fetchBoxStatus = async ({
    scanId,
    boxId
}: {
    scanId: number | string;
    boxId: number | string;
}): Promise<ImportStatus> =>
    client.get<ImportStatus>(`/scans/${scanId}/box/${boxId}/import/status`).then((res) => res.data);

export const importIntoScanOrBox = async ({
    payload,
    targetScanId,
    targetBoxId
}: ImportParams): Promise<ImportScanItemRes> => {
    if (!targetScanId && !targetBoxId) {
        console.error('Either targetScanId or targetBoxId must be provided');
    }
    const path = targetBoxId ? `scans/box/${targetBoxId}/import` : `scans/${targetScanId}/import`;
    return client.post(path, payload).then((res) => res.data);
};
